import { minor, type AccountingSnapshot, type Owner } from "../../money/types";

const knownAmount = (value: unknown): value is number => typeof value === "number" && Number.isSafeInteger(value) && value >= 0;
export function htxAvailability(snapshot: AccountingSnapshot, owner: Owner) {
  const cycles = snapshot.cycles.filter(c => c.owner_party === owner && c.status === "open");
  if (!cycles.length) return { amount: null, reason: "Нет открытого цикла", enabled: false };
  if (cycles.length !== 1) return { amount: null, reason: "Обновите сведения о цикле", enabled: false };
  const cycle = cycles[0];
  if (cycle.cancellation?.frozen || cycle.cancellation?.status === "pending" || ("is_paused" in cycle && cycle.is_paused === true))
    return { amount: null, reason: "Цикл приостановлен до решения по отмене", enabled: false };
  const account = snapshot.accounts.find(a => a.id === "kolya_wallet_usdt" && a.currency === "USDT");
  const balance = account?.owner_balances[owner];
  if (!knownAmount(balance) || !knownAmount(cycle.wallet_usdt_minor))
    return { amount: null, reason: "Остаток не подтверждён. Обновите сведения", enabled: false };
  const amount = Math.min(balance, cycle.wallet_usdt_minor);
  return { amount, reason: amount === 0 ? "На кошельке нет USDT этого цикла" : "", enabled: amount > 0 };
}

/** Exact editable tenths, including values near Number.MAX_SAFE_INTEGER. */
export function usdtInput(amount: number) {
  const units = BigInt(amount);
  return `${units / 10n}.${units % 10n}`;
}

export function htxTransferTotal(snapshot: AccountingSnapshot, values: { kolya: string; vlad: string }): number | null {
  try {
    let total = 0n;
    for (const who of ["kolya", "vlad"] as const) {
      const amount = values[who] ? minor(values[who], "USDT") : 0;
      if (!amount) continue;
      const available = htxAvailability(snapshot, who);
      if (!available.enabled || available.amount == null || amount > available.amount) return null;
      total += BigInt(amount);
    }
    return total > 0n && total <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(total) : null;
  } catch { return null; }
}
